import { ProductCard } from "./ProductCard";

export function ProductGrid({ products, columns = 4, className = "" }) {
  const gridClass =
    columns === 3
      ? "grid-cols-2 lg:grid-cols-3"
      : columns === 2
        ? "grid-cols-2"
        : "grid-cols-2 md:grid-cols-2 lg:grid-cols-4";

  return (
    <div className={`grid ${gridClass} gap-4 md:gap-6 lg:gap-8 ${className}`}>
      {products?.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
